import $ from "jquery";
import { isNullOrUndefined } from 'util';
import { AbconetApi } from '../General/AbconetApi';
import { isOutOfStock } from "../General/Helper";
import withCart from '../General/withCart';
import { OutOfStock } from './OutOfStock';
import { QuantitySelectorProduct } from "../General/QuantitySelectorProduct";
import { getStock } from "../Cart/CartFunctions";

class ProductAddToCartRaw extends React.Component {
    constructor(props) {
        super(props);
        var amount;
        var inCurrentOrder = false;

        if (props.cartItem) {
            amount = props.cartItem.quantity;
            inCurrentOrder = true;
        }

        this.state = {
            amount: amount,
            inCurrentOrder: inCurrentOrder,
            isSaving: false,
            minimumQuantity: null
        }
    }

    componentDidMount() {
        var self = this;
        setTimeout(() => {
            let stockSpecialOrder;
            if (this.props.cart && this.props.initialState.stockAvailability) {
                stockSpecialOrder = getStock(this.props.cart, this.props.initialState.stockAvailability);
            }
            this.setState({ minimumQuantity: stockSpecialOrder && stockSpecialOrder.minimumQuantity })
        },300);
    }

    addToTracking(stockcode, qty) {
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
                currency: "AUD",
                value: qty * this.props.initialState.bestPrice,
                items: [
                    {
                        item_id: stockcode,
                        item_name: this.props.initialState.name,
                        quantity: qty,
                        price: this.props.initialState.bestPrice
                    }
                ]
            }
        });
    }

    updateCart(ev) {
        this.addToTracking(this.props.stockcode, this.state.amount);
        ev.preventDefault();

        var self = this;
        this.setState({ isSaving: true });
        AbconetApi.post(`/api/cart/stockcode/${this.props.stockcode}`, this.state.amount).then(function (cart) {
            $(document).trigger("CartUpdated", cart);
            self.setState({
                inCurrentOrder: true,
                isSaving: false
            });
        });
    }


    updateAmount(ev) {
        if (ev.target.value <= 0) {
            this.setState({
                amount: 0
            });
        } else {
            this.setState({
                amount: ev.target.value
            });
        }
    }

    renderAddToOrderButton() {
   
        var btnClass = 'changes';
        var disabled = false;

        var buttonText = "Add to order";
        if (this.state.inCurrentOrder) {
            buttonText = "Update";
        }

        if (this.state.isSaving) {
            disabled = true;
            buttonText = "Updating";
            btnClass = 'saving';
        }


        if (!this.state.amount || (this.state.minimumQuantity && this.state.minimumQuantity > this.state.amount)) {
            disabled = true;
        }

        return <button href="#" className={"btn btn-secondary add-to-order " + btnClass} disabled={disabled} onClick={this.updateCart.bind(this)}>{buttonText}</button>;
    }

   
    render() {
        var supplyLocation = '';
        let stock;

        if (this.props.cart) {
            supplyLocation = this.props.cart.supplyLocation;
        }

        if ((isOutOfStock(supplyLocation, this.props.initialState) && this.props.initialState.cannotBeBackordered)) {
            return <div className={`add-to-cart-container`}><OutOfStock product={this.props.initialState} supplyLocation={supplyLocation}/></div>;
        }

        if (this.props.cart && this.props.initialState.stockAvailability) {
            stock = this.props.initialState.stockAvailability.find((location) => {
                return this.props.cart.supplyLocation == location.locationName && location.status == "SpecialOrderOnly";
            });
        }


        return <div className={`add-to-cart-container quantity-selector-product-container`}>
            <QuantitySelectorProduct cart={this.props.cart} item={this.props.initialState} onChange={this.updateAmount.bind(this)} value={this.state.amount ? this.state.amount : 0} unit={this.props.initialState ? this.props.initialState.unit : 'Unit'} unitPlural={this.props.initialState.unitPlural ? this.props.initialState.unitPlural : 'Units'} packQty={this.props.initialState.packQty ? this.props.initialState.packQty : 0} palletQty={this.props.initialState ? this.props.initialState.palletQty : null} layerQty={this.props.initialState ? this.props.initialState.layerQty : null} /> 
            {this.renderAddToOrderButton()}
        </div>;
    }
}

export const ProductAddToCart = withCart(ProductAddToCartRaw);

